module.exports = __webpack_public_path__ + "img/light-logo.ed8f22fa.png";